<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blueGray-200"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0 bg-teal-400">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1">
          <h3 class="font-semibold text-lg text-black">
            Timesheets
          </h3>
        </div>
        <div class="flex items-center justify-between mt-4 export-btn-wrap">
          <button
            type="button"
            class="btn_export_timesheet text-white text-sm font-bold uppercase px-4 py-2 rounded shadow outline-none focus:outline-none mr-2"
            @click="exportToPDF"
          >
            Export to PDF
          </button>
          <button
            type="button"
            class="btn_export_timesheet text-white text-sm font-bold uppercase px-4 py-2 rounded shadow outline-none focus:outline-none mr-2"
            @click="exportToExcel"
          >
            Export to Excel
          </button>
          <button
            type="button"
            class="btn_changes_timesheet text-white text-sm font-bold uppercase px-4 py-2 rounded shadow outline-none focus:outline-none"
            @click="openChangesModal"
          >
            Employee Changes
            <span
              v-if="activeChangesCount > 0"
              class="ml-2 bg-white text-red-600 rounded-full px-2 py-1 text-xs font-bold"
            >
              {{ activeChangesCount }}
            </span>
          </button>
        </div>
      </div>

      <div class="flex flex-wrap items-center mt-3">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1 timesheet-filters">
          <select
            name="filter_employees"
            id="employee_filter"
            v-model="f_employee"
            @change="apply_filter"
          >
            <option value="all">All Employees</option>
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id"
            >
              {{ employee.first_name }} {{ employee.last_name }}
            </option>
          </select>

          <select
            name="filter_month"
            id="filter_month"
            v-model="f_month"
            @change="apply_filter"
            class="ml-3"
          >
            <option value="all">All Months</option>
            <option v-for="month in months" :key="month" :value="month">
              {{ month }}
            </option>
          </select>

          <select
            name="filter_year"
            id="filter_year"
            v-model="f_year"
            @change="apply_filter"
            class="ml-3"
          >
            <option value="all">All Years</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>

          <input
            type="date"
            v-model="f_start_date"
            @change="apply_filter"
            class="ml-3 timesheet-date-input"
          />

          <input
            type="date"
            v-model="f_end_date"
            @change="apply_filter"
            class="ml-3 timesheet-date-input"
          />

          <button
            type="button"
            class="btn_export_timesheet text-white text-sm font-bold uppercase px-4 py-2 rounded shadow outline-none focus:outline-none ml-3"
            @click="clearDateFilter"
          >
            Clear Dates
          </button>
        </div>
      </div>
    </div>

    <div class="block w-full overflow-x-auto xport_pdf">
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
          <tr>
            <th
              class="text-white px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-600"
            >
              Date
            </th>
            <th
              class="text-white px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-600"
            >
              Time In
            </th>
            <th
              class="text-white px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-600"
            >
              Time Out
            </th>
            <th
              class="text-white px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-600"
            >
              Total Hours
            </th>
            <th
              class="text-white px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center bg-blueGray-600"
            >
              Service Code
            </th>
            <th
              class="text-white px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center bg-blueGray-600"
            >
              Employee
            </th>
            <th
              class="text-white px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center bg-blueGray-600"
            >
              Status
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="timesheet in filtered_sheets"
            :key="timesheet.id"
            class="border-b border-gray-300"
          >
            <td class="px-6 align-middle py-3 text-xs whitespace-nowrap font-semibold text-left">
              {{ timesheet.start_date }}
            </td>
            <td class="px-6 align-middle py-3 text-xs whitespace-nowrap font-semibold text-left">
              {{ timesheet.start_time }}
            </td>
            <td class="px-6 align-middle py-3 text-xs whitespace-nowrap font-semibold text-left">
              {{ timesheet.end_time }}
            </td>
            <td class="px-6 align-middle py-3 text-xs whitespace-nowrap font-semibold text-left">
              {{ timesheet.total_hours }}
            </td>
            <td class="px-6 align-middle py-3 text-xs whitespace-nowrap font-semibold text-left">
              {{ timesheet.service_code }}
            </td>
            <td class="px-6 align-middle py-3 text-xs whitespace-nowrap font-semibold text-left">
              {{ getEmployeeName(timesheet.employee) }}
            </td>
            <td class="px-6 align-middle py-3 text-xs whitespace-nowrap font-semibold text-left">
              <div v-if="timesheet.status == 0">
                <span class="text-xs font-weight-bold">Pending</span>
              </div>
              <div v-else-if="timesheet.status == 1">
                <span class="text-xs font-weight-bold">Approved</span>
              </div>
              <div v-else>
                <span class="text-xs font-weight-bold">Declined</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="showChangesModal" class="changes-modal-backdrop">
      <div class="changes-modal-card">
        <div class="changes-modal-header">
          <div>
            <h3 class="text-xl font-bold text-black">Employee Timesheet Changes</h3>
            <p class="text-sm text-gray-600 mt-1">
              Direct employee edits and deletes recorded by the new audit system.
            </p>
          </div>
          <button class="changes-close-btn" @click="closeChangesModal">
            ✕
          </button>
        </div>

        <div class="changes-modal-toolbar">
          <button
            type="button"
            class="changes-scope-btn"
            :class="{ active: changeScope === 'active' }"
            @click="setChangeScope('active')"
          >
            Active
          </button>
          <button
            type="button"
            class="changes-scope-btn"
            :class="{ active: changeScope === 'all' }"
            @click="setChangeScope('all')"
          >
            All
          </button>
          <button
            type="button"
            class="changes-refresh-btn"
            @click="fetchChangeLogs"
          >
            Refresh
          </button>
        </div>

        <div class="changes-modal-body">
          <div v-if="changeLogsLoading" class="py-10 text-center text-gray-600">
            Loading changes...
          </div>

          <div v-else-if="changeLogs.length === 0" class="py-10 text-center text-gray-600">
            No employee change logs found.
          </div>

          <div
            v-for="log in changeLogs"
            :key="log.id"
            class="change-log-card"
          >
            <div class="change-log-top">
              <div>
                <h4 class="font-bold text-base text-black">
                  {{ getEmployeeName(log.employee) || "Unknown Employee" }}
                </h4>
                <p class="text-sm text-gray-600">
                  Change #{{ log.id }} • Timesheet #{{ log.timesheet_id || "-" }}
                </p>
              </div>

              <div class="change-log-badges">
                <span class="change-type-badge" :class="log.change_type">
                  {{ (log.change_type || "unknown").toUpperCase() }}
                </span>
                <span class="change-status-badge" :class="log.change_status">
                  {{ (log.change_status || "unknown").toUpperCase() }}
                </span>
              </div>
            </div>

            <div class="change-log-meta">
              <p><strong>Employee reason:</strong> {{ log.employee_reason || "-" }}</p>
              <p><strong>Changed at:</strong> {{ formatDateTime(log.created_at) }}</p>
              <p v-if="log.admin_reason"><strong>Admin reason:</strong> {{ log.admin_reason }}</p>
              <p v-if="log.reverted_at"><strong>Reverted at:</strong> {{ formatDateTime(log.reverted_at) }}</p>
            </div>

            <div class="change-log-grid">
              <div class="change-log-box">
                <h5 class="change-log-title">Original</h5>
                <p><strong>Date:</strong> {{ payloadField(log.original_payload, "start_date") || "-" }}</p>
                <p><strong>Time In:</strong> {{ payloadField(log.original_payload, "start_time") || "-" }}</p>
                <p><strong>Time Out:</strong> {{ payloadField(log.original_payload, "end_time") || "-" }}</p>
                <p><strong>Total Hours:</strong> {{ payloadField(log.original_payload, "total_hours") || "-" }}</p>
                <p><strong>Service Code:</strong> {{ payloadField(log.original_payload, "service_code") || "-" }}</p>
                <p><strong>Specification:</strong> {{ payloadField(log.original_payload, "specification") || "-" }}</p>
              </div>

              <div class="change-log-box">
                <h5 class="change-log-title">New</h5>
                <template v-if="log.change_type === 'delete'">
                  <p class="text-red-600 font-semibold">This timesheet was deleted.</p>
                </template>
                <template v-else>
                  <p><strong>Date:</strong> {{ payloadField(log.new_payload, "start_date") || "-" }}</p>
                  <p><strong>Time In:</strong> {{ payloadField(log.new_payload, "start_time") || "-" }}</p>
                  <p><strong>Time Out:</strong> {{ payloadField(log.new_payload, "end_time") || "-" }}</p>
                  <p><strong>Total Hours:</strong> {{ payloadField(log.new_payload, "total_hours") || "-" }}</p>
                  <p><strong>Service Code:</strong> {{ payloadField(log.new_payload, "service_code") || "-" }}</p>
                  <p><strong>Specification:</strong> {{ payloadField(log.new_payload, "specification") || "-" }}</p>
                </template>
              </div>
            </div>

            <div class="change-log-actions" v-if="log.change_status === 'applied'">
              <button
                type="button"
                class="btn-revert-change"
                @click="revertChange(log)"
              >
                Revert Change
              </button>
            </div>
          </div>
        </div>

        <div class="changes-modal-footer">
          <button class="changes-close-btn" @click="closeChangesModal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import jsPDF from "jspdf";
import $ from "jquery";
import html2canvas from "html2canvas";

export default {
  data() {
    const currentYear = new Date().getFullYear();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const years = [];
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      years.push(i);
    }

    return {
      timesheets: [],
      employees: [],
      f_employee: "all",
      filtered_sheets: [],
      years: years,
      f_year: "all",
      f_month: "all",
      months: months,
      f_start_date: "",
      f_end_date: "",
      showChangesModal: false,
      changeLogs: [],
      changeLogsLoading: false,
      changeScope: "active",
    };
  },

  computed: {
    activeChangesCount() {
      return this.changeLogs.filter((log) => log.change_status === "applied").length;
    },
  },

  methods: {
    async fetch_timesheets() {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/timesheets_client`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.timesheets = response.data.data || [];
        this.apply_filter();
      } catch (error) {
        console.error("Backend error:", error);
      }
    },

    async fetch_employees() {
      const token = localStorage.getItem("token");

      const params_data = {
        token: token,
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/fetch_employees`,
          params_data
        );
        this.employees = response.data || [];
      } catch (error) {
        console.error("Backend error:", error);
      }
    },

    async fetchChangeLogs() {
      this.changeLogsLoading = true;

      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/timesheet-change-logs?scope=${this.changeScope}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        this.changeLogs = response.data.data || [];
      } catch (error) {
        console.error("Change logs error:", error);
        this.changeLogs = [];
        Swal.fire({
          icon: "error",
          title: "Could not load employee changes",
          text: error?.response?.data?.message || "Please try again.",
        });
      } finally {
        this.changeLogsLoading = false;
      }
    },

    async openChangesModal() {
      this.showChangesModal = true;
      await this.fetchChangeLogs();
    },

    closeChangesModal() {
      this.showChangesModal = false;
    },

    async setChangeScope(scope) {
      this.changeScope = scope;
      await this.fetchChangeLogs();
    },

    async revertChange(log) {
      const result = await Swal.fire({
        title: "Revert this change?",
        text: "This will restore the original timesheet values.",
        input: "textarea",
        inputLabel: "Admin reason",
        inputPlaceholder: "Reason for reverting this employee change",
        inputAttributes: {
          "aria-label": "Admin reason",
        },
        showCancelButton: true,
        confirmButtonText: "Revert",
        confirmButtonColor: "#dc2626",
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return "Admin reason is required.";
          }
          return null;
        },
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        const token = localStorage.getItem("token");
        await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/timesheet-change-logs/${log.id}/revert`,
          {
            admin_reason: result.value.trim(),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        Swal.fire({
          icon: "success",
          title: "Reverted",
          text: "The employee change has been reverted.",
          timer: 1500,
          showConfirmButton: false,
        });

        await this.fetchChangeLogs();
        await this.fetch_timesheets();
      } catch (error) {
        console.error("Revert error:", error);
        Swal.fire({
          icon: "error",
          title: "Revert failed",
          text: error?.response?.data?.message || "Please try again.",
        });
      }
    },

    getEmployeeName(employee) {
      if (!employee) {
        return "";
      }
      return `${employee.first_name || ""} ${employee.last_name || ""}`.trim();
    },

    payloadField(payload, key) {
      if (!payload || typeof payload !== "object") {
        return "";
      }
      return payload[key];
    },

    formatDateTime(value) {
      if (!value) {
        return "-";
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      return date.toLocaleString();
    },

    async declined(id, status) {
      let message = "Are you sure you want to decline this?";
      let icon = "warning";

      if (status == "1") {
        message = "Are you sure you want to approve this timesheet?";
        icon = "info";
      }

      Swal.fire({
        title: message,
        text: "You won't be able to revert this!",
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Proceed",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem("token");
            const response = await axios.post(
              `${process.env.VUE_APP_BACKEND_DOMAIN}/api/decline_timesheet`,
              { time_sheet_id: id, status },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            if (response.status == 201) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "timesheet approved",
                showConfirmButton: false,
                timer: 1500,
              });
              this.fetch_timesheets();
            } else {
              Swal.fire({
                position: "bottom-end",
                icon: "error",
                title: response.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          } catch (error) {
            console.error("Backend error:", error);
          }
        }
      });
    },

    apply_filter() {
      const filtered = this.timesheets.filter((timesheet) => {
        const startDate = new Date(timesheet.start_date);
        const startYear = startDate.getFullYear();
        const startMonth = startDate.getMonth();

        const matchesEmployee =
          this.f_employee === "all" || timesheet.employee_id == this.f_employee;

        const matchesMonth =
          this.f_month === "all" || this.months[startMonth] === this.f_month;

        const matchesYear =
          this.f_year === "all" || startYear == this.f_year;

        const matchesStartDate =
          !this.f_start_date ||
          new Date(timesheet.start_date) >= new Date(this.f_start_date);

        const matchesEndDate =
          !this.f_end_date ||
          new Date(timesheet.start_date) <= new Date(this.f_end_date);

        return (
          matchesEmployee &&
          matchesMonth &&
          matchesYear &&
          matchesStartDate &&
          matchesEndDate
        );
      });

      this.filtered_sheets = filtered.sort((a, b) => {
        const aDate = new Date(`${a.start_date} ${a.start_time || "00:00:00"}`);
        const bDate = new Date(`${b.start_date} ${b.start_time || "00:00:00"}`);
        return bDate - aDate;
      });
    },

    clearDateFilter() {
      this.f_start_date = "";
      this.f_end_date = "";
      this.apply_filter();
    },

    exportToPDF() {
      const month_entry = $("#filter_month").val();
      const year_entry = $("#filter_year").val();
      const filename = `timesheets_${month_entry}_${year_entry}.pdf`;
      const pdf = new jsPDF("p", "pt", "a4");

      const element = document.querySelector(".xport_pdf");

      const pdfWidth = 595.28;
      const pdfHeight = 841.89;

      const widthRatio = pdfWidth / element.offsetWidth;
      const heightRatio = pdfHeight / element.offsetHeight;
      const scaleFactor = Math.min(widthRatio, heightRatio);

      const scaledWidth = element.offsetWidth * scaleFactor;
      const scaledHeight = element.offsetHeight * scaleFactor;

      html2canvas(element, {
        useCORS: true,
        logging: true,
        allowTaint: false,
        width: scaledWidth,
        height: scaledHeight,
        scale: scaleFactor,
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const imgWidth = pdfWidth;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
          pdf.save(filename);
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
        });
    },

    exportToExcel() {
      const month_entry = $("#filter_month").val();
      const year_entry = $("#filter_year").val();
      const filename = `timesheets_${month_entry}_${year_entry}.csv`;
      const csvContent = this.convertToCSV(this.filtered_sheets);

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    convertToCSV(data) {
      const headers = [
        "Time In",
        "Time Out",
        "Total Hours",
        "Service Code",
        "Specification",
        "Status",
      ];

      const csv = data
        .map((row) => {
          return [
            `${row.start_date} ${row.start_time}`,
            `${row.end_date} ${row.end_time}`,
            `${row.total_hours}`,
            `${row.service_code}`,
            `${row.specification ?? "No specifications"}`,
            `${row.status === 0 ? "Pending" : row.status === 1 ? "Approved" : "Declined"}`,
          ].join(",");
        })
        .join("\n");

      return `${headers.join(",")}\n${csv}`;
    },
  },

  mounted() {
    this.fetch_timesheets();
    this.fetch_employees();
    this.fetchChangeLogs();
  },
};
</script>

<style scoped>
.btn_export_timesheet {
  background-color: #059669 !important;
}

.btn_changes_timesheet {
  background-color: #dc2626 !important;
}

.timesheet-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.timesheet-date-input {
  min-width: 160px;
}

.export-btn-wrap {
  flex-wrap: wrap;
  gap: 0.5rem;
}

.changes-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
}

.changes-modal-card {
  width: 100%;
  max-width: 1100px;
  max-height: 90vh;
  overflow: hidden;
  background: white;
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}

.changes-modal-header,
.changes-modal-footer,
.changes-modal-toolbar {
  padding: 16px 24px;
}

.changes-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #e5e7eb;
}

.changes-modal-toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}

.changes-modal-body {
  padding: 20px 24px;
  overflow-y: auto;
}

.changes-modal-footer {
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
}

.changes-close-btn,
.changes-refresh-btn,
.changes-scope-btn {
  border: none;
  cursor: pointer;
  font-weight: 700;
  border-radius: 8px;
  padding: 8px 14px;
}

.changes-close-btn,
.changes-refresh-btn {
  background: #e5e7eb;
  color: #111827;
}

.changes-scope-btn {
  background: #cbd5e1;
  color: #0f172a;
}

.changes-scope-btn.active {
  background: #0f766e;
  color: white;
}

.change-log-card {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 18px;
  margin-bottom: 16px;
  background: #f9fafb;
}

.change-log-top {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.change-log-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.change-type-badge,
.change-status-badge {
  padding: 6px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 700;
}

.change-type-badge.edit {
  background: #dbeafe;
  color: #1d4ed8;
}

.change-type-badge.delete {
  background: #fee2e2;
  color: #b91c1c;
}

.change-status-badge.applied {
  background: #dcfce7;
  color: #166534;
}

.change-status-badge.reverted {
  background: #f3f4f6;
  color: #374151;
}

.change-log-meta {
  margin-bottom: 16px;
  font-size: 14px;
  color: #374151;
}

.change-log-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.change-log-box {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px;
}

.change-log-title {
  font-weight: 800;
  margin-bottom: 10px;
  color: #111827;
}

.change-log-actions {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
}

.btn-revert-change {
  background: #dc2626;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 768px) {
  .timesheet-filters > * {
    width: 100%;
    margin-left: 0 !important;
  }

  .export-btn-wrap {
    width: 100%;
  }

  .export-btn-wrap > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .change-log-grid {
    grid-template-columns: 1fr;
  }

  .changes-modal-card {
    max-height: 95vh;
  }
}
</style>
